




































































import { getCurrentUserProfileData } from '@/models/userProfile'
import { AxUser } from '@/types/AxUserType'
import { cecPaths } from '../cecSitePath'
import { CartDisplayItem } from '../types/carts'


    export default {
        data() {
            return {
            initialized: false as boolean,
            user: null as AxUser,
            isLoggedIn: false as boolean,
            quantity: 0 as number,
            pagePath: cecPaths,
            cartItem: null as CartDisplayItem,
            standardItemCount: 0 as number,
            regularItemCount: 0 as number,
            turi:'/wp-content/themes/hwf-staticec'
            }
        },
        async mounted(){
            if(this.$AxE2.isLoggedIn){
                await this.fetchCurrentUser()
                this.isLoggedIn = true
                this.$AxE2.memberId = this.user.custom.cloudk_memberid
            } else{
              this.$AxE2.memberId = ""
            }
            console.log('this.user: ',this.user)
            console.log('window: ', window)
            console.log('this.$AxE2.memberId: ', this.$AxE2.memberId)

            await this.getCart()
            this.initialized = true
        },
        methods:{
            async fetchCurrentUser(){
                this.user = await getCurrentUserProfileData()
            },
            async getCart() {
                this.cartItem = await this.$AxE2.$cart.getDisplayCartItems()
                if (this.cartItem) {
                    this.standardItemCount = Object.keys(this.cartItem.standardCartItemData.items).length
                    this.regularItemCount = Object.keys(this.cartItem.regularCartItemData.items).length
                    this.quantity = this.regularItemCount + this.standardItemCount
                } else {
                    this.standardItemCount = 0
                    this.regularItemCount = 0
                    this.quantity = this.regularItemCount + this.standardItemCount
                }
            },
        }
    }
